import { Component, OnInit } from '@angular/core';
import {NavController} from "@ionic/angular";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {UserService} from "../../../shared/service/user.service";
import {OnesignalService} from "../../../shared/service/onesignal.service";
import {NavigationService} from "../../../shared/service/navigation.service";
import {CommonService} from "../../../shared/service/common.service";

@Component({
  selector: 'app-login-mail',
  templateUrl: './login-mail.component.html',
  styleUrls: ['./login-mail.component.scss']
})
export class LoginMailComponent  implements OnInit {

  loginProgress: boolean;
  loginForm: FormGroup = this.fb.group({
    email: [undefined, [Validators.required, Validators.email]],
    password: [undefined, [Validators.required]]
  });

  constructor(private fb: FormBuilder,
              private onesignalService: OnesignalService,
              private navigationService: NavigationService,
              private commonService: CommonService,
              private navController: NavController,
              private userService: UserService) { }

  ngOnInit() {}


  onRegister(){
    this.navigationService.forwardModal('register_mail');
  }

  onLogin() {

    this.loginProgress = true;

    setTimeout(() => {
      const {email, password} = this.loginForm.value;
      this.userService.login(email, password).subscribe((res) => {
        this.onesignalService.initOneSignal(res?.id?.toString());
        this.userService.username = this.loginForm.value.email;
        this.loginProgress = false;
        if (this.userService.user?.mailConfirmed) {
          this.navigationService.goRoot(this.navigationService.navigationAfterLogin);
        } else {
          this.userService.logout();
          this.navController.navigateForward(['/mail-verified']);
        }

        this.navigationService.closeModal();

      }, (error) => {
        this.commonService.presentAlertMsg("Error occured", 'APP_ERRORS.' + error?.error?.message);
        this.loginProgress = false;
      });
    }, 600);

  }

  onResetPassword() {

    this.commonService.onToggleMainLoader();

    if (!this.loginForm.value.email) {
      this.commonService.onToggleMainLoader();
      this.commonService.presentAlertMsg('Email mancante', 'Per reimpostare la password, inserisci prima l\'indirizzo email nel campo di accesso.');
      return;
    }

    this.userService.resetPwd(this.loginForm.value.email).subscribe(() => {
      this.commonService.onToggleMainLoader();
      this.commonService.presentAlertMsg('Controlla la tua email', 'Ti abbiamo inviato un\'email con le istruzioni per reimpostare la password. Controlla la casella di posta.');
    }, (error) => {
      this.commonService.onToggleMainLoader();
      if (error?.status === 404) {
        this.commonService.presentAlertMsg('Email non trovata', 'L\'indirizzo email inserito non è associato a nessun account. Verifica e riprova.');
      }
    });

  }
}
